import { observable, action, computed, createTransformer, reaction } from "mobx";
import TarefaService from "../../../services/TarefaService";
import FluxoService from "../../../services/FluxoService";

export default class SolicitacoesPendentesStore {

    @observable solicitacoesPendentesLista;
    @observable loading;

    constructor() {
        this.solicitacoesPendentesLista = [];

        this.tarefaService = new TarefaService()
        this.fluxoService = new FluxoService()
    }

    async carregarLista() {
        this.loading = true;
        this.solicitacoesPendentesLista = [];

        // const promiseTarefas = this.tarefaService.listSolicitacoesPorUsuario("pendentesId")
        //     .catch(err => {
        //         console.error("Falha ao carregar solicitações por tarefa:", (err.response && err.response.data && err.response.data.message) || err.message);
        //         return { data: [] }; // Retorna um objeto com 'data' vazio para não quebrar o Promise.all
        //     });

        try {
            // const [responseTarefas, responseFluxo] = await Promise.all([promiseTarefas, promiseFluxo]);
            const responseFluxo = await this.fluxoService.listarTarefasSolicitacaoPorUsuario()
                .catch(err => {
                    console.error("Falha ao carregar tarefas de solicitação por usuário:", (err.response && err.response.data && err.response.data.message) || err.message);
                    return { data: [] }; // Retorna um objeto com 'data' vazio para não quebrar a execução
                });

            // const listaTarefas = responseTarefas.data || [];
            const listaUnificada = responseFluxo.data || [];

            // Ordena a lista pelo campo 'prazo' (data mais antiga primeiro).
            // Itens sem prazo definido são movidos para o final da lista.
            listaUnificada.sort((a, b) => {
                if (!a.prazo) return 1; // Joga itens sem prazo para o fim
                if (!b.prazo) return -1; // Joga itens sem prazo para o fim

                // Converte a string "DD/MM/YYYY" para um objeto Date válido
                const [diaA, mesA, anoA] = a.prazo.split('/');
                const dateA = new Date(`${anoA}-${mesA}-${diaA}`);

                const [diaB, mesB, anoB] = b.prazo.split('/');
                const dateB = new Date(`${anoB}-${mesB}-${diaB}`);

                return dateA - dateB;
            });

            this.solicitacoesPendentesLista = listaUnificada;
        } catch (error) {
            // Este catch agora só será acionado por erros de programação dentro do try
            console.error("Ocorreu um erro inesperado ao processar as solicitações:", error);
        } finally {
            this.loading = false;
        }
    }

    fluxoFormatter(nomeFluxo){
        switch(nomeFluxo) {
            case "GloboMOTSolicitacaoMOT":
            case "SolicitacaoContratacao":
                nomeFluxo = "Solicitação de contratação";
                break;
            case "GloboMOTSolicitacaoEtt":
            case "SolicitacaoEtt":
                nomeFluxo = "Contratação";
                break;
            case "GloboMOTSolicitacaoTerminoAntecipado":
            case "SolicitacaoTerminoAntecipado":
                nomeFluxo = "Solicitação de Término Antecipado";
                break;
            case "GloboMOTSolicitacaoProrrogacao":
            case "SolicitacaoProrrogacao":
                nomeFluxo = "Solicitação de prorrogação";
                break;
        }
        return nomeFluxo;
    }

    setLista(value) {
        this.solicitacoesPendentesLista = value;
    }
}